import {
	Component,
	ElementRef,
	HostListener,
	Input,
	OnInit,
	ViewChild
} from '@angular/core';
import { FileInput } from '@app/shared/form/models/inputs/file-input';
import { NbButtonModule, NbInputModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-file-input',
	templateUrl: './file-input.component.html',
	styleUrls: ['./file-input.component.scss'],
	standalone: true,
	imports: [NbInputModule, NbButtonModule, TranslateModule]
})
export class FileInputComponent extends BaseInputComponent implements OnInit {
	@ViewChild('fileTag') fileTag: ElementRef<HTMLInputElement>;
	@Input({ required: true }) override control: FileInput;
	@Input() size: string;
	onChange: () => any;
	file: File | null = null;
	fileName: string;

	ngOnInit(): void {
		this.file = null;
		this.control.reset();
		this.control.statusChanges.subscribe(() => {
			if (!this.hasFile) {
				this.fileTag.nativeElement.value = null;
				this.file = null;
			}
		});
	}

	get hasFile(): boolean {
		return !!this.control.value;
	}

	@HostListener('change', ['$event.target.files']) emitFiles(
		event: FileList
	) {
		const file = event && event.item(0);
		this.file = file;
		this.fileName = file.name.toString();
		this.control.setValue(this.file);
	}

	btnClick() {
		if (!this.file) {
			this.fileTag.nativeElement.click();
		} else {
			this.control.reset();
			this.fileTag.nativeElement.value = null;
			this.file = null;
			this.fileTag.nativeElement.click();
		}
	}
}
